import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import styled from "styled-components";
import PublicStyledTableCell from "../../publics/PublicStyledTableCell";
import { CLOUDN_COLORS } from "../../../constants/colors";
import { ShowcaseTableProps } from "../../../constants/types";
import { useEffect, useState } from "react";
import ShowcaseTableRow from "../../atoms/\bshowcase/ShowcaseTableRow";

const ShowcaseTable = (props: ShowcaseTableProps) => {
  const [rows, setRows] = useState<JSX.Element[]>([]);

  // useEffect(() => {
  //   setRows(
  //     props.data.map((data, index) => (
  //       <ShowcaseTableRow data={data} key={index} />
  //     ))
  //   );
  // }, [props.data]);

  useEffect(() => {
    const list = props.data
      .slice(props.page.state * 30, props.page.state * 30 + 30)
      .map((data, index) => <ShowcaseTableRow data={data} key={index} />);
    setRows(list);
  }, [props.data, props.page.state]);
  return (
    <Container>
      <TableContainer
        sx={{
          width: "100%",
          height: "100%",
          borderBottom: `0.2vw solid ${CLOUDN_COLORS.logoSkyBlue}`,
        }}
      >
        <Table
          style={{
            width: "100%",
            borderSpacing: 0,
          }}
          stickyHeader
        >
          <TableHead>
            <TableRow>
              <PublicStyledTableCell>상태</PublicStyledTableCell>
              <PublicStyledTableCell>지점명</PublicStyledTableCell>
              <PublicStyledTableCell>S/C</PublicStyledTableCell>
              <PublicStyledTableCell>ID</PublicStyledTableCell>
              <PublicStyledTableCell>온도(°C)</PublicStyledTableCell>
              <PublicStyledTableCell>배터리(V)</PublicStyledTableCell>
              <PublicStyledTableCell>기준온도(°C)</PublicStyledTableCell>
              <PublicStyledTableCell>
                마지막 통신 데이터 시간
              </PublicStyledTableCell>
              <PublicStyledTableCell>비고</PublicStyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{rows}</TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ShowcaseTable;

const Container = styled.div`
  width: 100%;
  height: 87%;
`;
